/** biome-ignore-all lint/suspicious/noArrayIndexKey: <explanation> */
"use client";

import { c as _c } from "react/compiler-runtime";
import Image, { type StaticImageData } from "next/image";
import { useRef } from "react";
import Logo_Ajinomoto from "~/public/assets/clients/logo-ajinomoto.png";
import Logo_Algar from "~/public/assets/clients/logo-algar.png";
import Logo_Bosch from "~/public/assets/clients/logo-bosch.png";
import Logo_Estadao from "~/public/assets/clients/logo-estadao.png";
import Logo_Ultragaz from "~/public/assets/clients/logo-ultragaz.png";
import Logo_Unicesumar from "~/public/assets/clients/logo-unicesumar.png";
import { useClientsAnimation } from "./use-clients-animation";
type ClientLogo = {
  src: StaticImageData | string;
  name: string;
};
export type ClientsSectionProps = {
  logos?: ClientLogo[];
  isBgLight?: boolean;
  isServicePage?: boolean;
  tag?: string;
  title?: string;
};
const defaultClientLogos: ClientLogo[] = [{
  src: Logo_Ultragaz,
  name: "Ultragaz"
}, {
  src: Logo_Estadao,
  name: "Estadão"
}, {
  src: Logo_Bosch,
  name: "Bosch"
}, {
  src: Logo_Algar,
  name: "Algar"
}, {
  src: Logo_Ajinomoto,
  name: "Ajinomoto"
}, {
  src: Logo_Unicesumar,
  name: "Unicesumar"
}];
function getLogoKey(logo: ClientLogo) {
  return typeof logo.src === "string" ? logo.src : logo.src.src;
}
export default function ClientsSection(t0) {
  const $ = _c(50);
  const {
    logos: t1,
    isBgLight: t2,
    isServicePage: t3,
    tag: t4,
    title: t5
  } = t0;
  const logos = t1 === undefined ? defaultClientLogos : t1;
  const isBgLight = t2 === undefined ? false : t2;
  const isServicePage = t3 === undefined ? false : t3;
  const tag = t4 === undefined ? "Nossos clientes" : t4;
  const title = t5 === undefined ? "Marcas que confiam na Flow para criar produtos digitais." : t5;
  const containerRef = useRef(null);
  useClientsAnimation(containerRef);
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== isBgLight || $[1] !== isServicePage || $[2] !== logos || $[3] !== tag || $[4] !== title) {
    const carouselLogos = [...logos, ...logos];
    t14 = containerRef;
    t15 = `clients-section relative border-t border-gray-300 md:container-padding ${!isBgLight ? "bg-gray-1100" : ""}`;
    t16 = "clientes";
    t9 = "container relative mx-auto md:border-x border-gray-300";
    const t17 = `hidden md:inline-flex absolute -top-1.75 -left-1.5 z-20 h-3 w-3 border border-gray-300 ${!isBgLight ? "bg-gray-1100" : "bg-gray-1000"}`;
    if ($[16] !== t17) {
      t10 = <span className={t17} />;
      $[16] = t17;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    const t18 = `hidden md:inline-flex absolute -top-1.75 -right-1.5 z-20 h-3 w-3 border border-gray-300 ${!isBgLight ? "bg-gray-1100" : "bg-gray-1000"}`;
    if ($[18] !== t18) {
      t11 = <span className={t18} />;
      $[18] = t18;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    if ($[20] !== isBgLight || $[21] !== isServicePage || $[22] !== tag || $[23] !== title) {
      t12 = isBgLight && <div className={`px-6 pt-20 pb-16 md:pt-30 lg:px-18 3xl:px-24! ${isServicePage ? "max-w-180" : "mx-auto md:text-center"}`}><p className="tag">{tag}</p><h2 className="title">{title}</h2></div>;
      $[20] = isBgLight;
      $[21] = isServicePage;
      $[22] = tag;
      $[23] = title;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t19;
    if ($[25] !== isBgLight || $[26] !== logos) {
      let t20;
      if ($[28] !== isBgLight) {
        t20 = logo => <div key={getLogoKey(logo)} className={`logo-card flex items-center justify-center border-r border-gray-300 px-4 py-6 md:max-h-23.25 md:px-6 md:py-8 first:border-l-0 last:border-r-0 ${isBgLight ? "border-t" : ""}`}><LogoImage logo={logo} imageClassName="max-h-10 max-w-28 object-contain md:max-h-11 md:max-w-32 lg:max-h-10 lg:max-w-31" sizes="(max-width: 640px) 96px, 124px" /></div>;
        $[28] = isBgLight;
        $[29] = t20;
      } else {
        t20 = $[29];
      }
      t19 = logos.map(t20);
      $[25] = isBgLight;
      $[26] = logos;
      $[27] = t19;
    } else {
      t19 = $[27];
    }
    if ($[30] !== t19) {
      t13 = <div className="hidden lg:grid lg:grid-cols-6">{t19}</div>;
      $[30] = t19;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    t8 = "clients-carousel md:overflow-hidden border-gray-300 lg:hidden";
    t6 = "clients-carousel-track flex w-max items-stretch motion-reduce:animate-none";
    t7 = carouselLogos.map((logo_0, index) => <div key={`${getLogoKey(logo_0)}-${index}`} aria-hidden={index >= logos.length} className="logo-card flex min-h-23.25 min-w-40 shrink-0 items-center justify-center border border-gray-300 px-5 py-6 sm:min-w-48 sm:px-6"><LogoImage logo={logo_0} imageClassName="max-h-10 max-w-30 object-contain md:max-h-11 md:max-w-32 lg:max-h-10 lg:max-w-31" sizes="(max-width: 639px) 120px, (max-width: 1023px) 132px, 124px" /></div>);
    $[0] = isBgLight;
    $[1] = isServicePage;
    $[2] = logos;
    $[3] = tag;
    $[4] = title;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t17;
  if ($[32] !== t6 || $[33] !== t7) {
    t17 = <div className={t6}>{t7}</div>;
    $[32] = t6;
    $[33] = t7;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17 || $[36] !== t8) {
    t18 = <div className={t8}>{t17}</div>;
    $[35] = t17;
    $[36] = t8;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t18 || $[43] !== t9) {
    t19 = <div className={t9}>{t10}{t11}{t12}{t13}{t18}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t18;
    $[43] = t9;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t14 || $[46] !== t15 || $[47] !== t16 || $[48] !== t19) {
    t20 = <div ref={t14} className={t15} id={t16}>{t19}</div>;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
}
type LogoImageProps = {
  logo?: ClientLogo;
  imageClassName: string;
  sizes: string;
};
function LogoImage(t0) {
  const $ = _c(5);
  const {
    logo,
    imageClassName,
    sizes
  } = t0;
  if (!logo) {
    return null;
  }
  const t1 = `Logo ${logo.name}`;
  let t2;
  if ($[0] !== imageClassName || $[1] !== logo.src || $[2] !== sizes || $[3] !== t1) {
    t2 = <div className="relative flex min-h-10 w-full items-center justify-center overflow-hidden"><Image alt={t1} className={imageClassName} height={2000} sizes={sizes} src={logo.src} width={2000} /></div>;
    $[0] = imageClassName;
    $[1] = logo.src;
    $[2] = sizes;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}